import { ATTENDANCE_MANAGEMENT_FR_FR } from "../attendance-management/translations/attendance-management-fr-fr";
import { BarsAndSectorsTranslations } from "./bars-and-sectors-pt-br";

export const BARS_AND_SECTORS_FR_FR: BarsAndSectorsTranslations = {
	title: "Bars",
	barsAndSectors: "Bars et Secteurs",
	description:
		"Gérez et personnalisez les paramètres d'inventaire, d'imprimante et de menu pour les bars.",
	bars: "Bars",
	sectors: "Secteurs",
	generalSettings: "Paramètres généraux",
	printByTableSettings: "Configurer l'impression des tables",
	attendanceManagement: ATTENDANCE_MANAGEMENT_FR_FR,
	editSector: "Modifier le secteur",
	createSector: "Créer un secteur",
	createNewSector: "Créer un nouveau secteur",
	newSector: "Nouveau secteur",
	searchPlaceholderSector: "Rechercher par nom de secteur ou bar",
	searchPlaceholderAccess: "Rechercher par nom d'accès",
	sectorName: "Nom du secteur",
	sectorBars: "Bars du secteur",
	accessControl: "Contrôle d'accès",
	createAccess: "Créer un accès",
	newAccess: "Nouveau accès",
	editAccess: "Modifier l'accès",
	createNewAccess: "Créer un nouveau accès",
	accessName: "Nom de l'accès",
	initialDate: "Début",
	endDate: "Fin",
	range: "Gamme de ZigCards",
	zigCardsId: "ID ZigCard",
	downloadModel: "Télécharger le modèle",
	selectFile: "Sélectionner un fichier",
	selectFileDescription: "Type de fichier [.xlsx, .xls] jusqu'à [500 mb].",
	removeFile: "Supprimer le fichier",
	createAccessSuccess: "Accès créé avec succès",
	editAccessSuccess: "Accès modifié avec succès",
	name: "Nom",
	initialDateHour: "Date et heure initiale",
	endDateHour: "Date et heure finale",
	deleteSector: "Exclure le secteur",
	deleteSectorSubtitle: "Êtes-vous sûr de vouloir exclure le secteur?",
	deleteSectorSuccess: "Secteur exclu avec succès",
	editSectorSuccess: "Secteur modifié avec succès",
	createSectorSuccess: "Secteur créé avec succès",
	deleteAccessPolicy: "Exclure l'accès",
	deleteAccessPolicySubtitle: "Êtes-vous sûr de vouloir exclure l'accès?",
	deleteAccessPolicySuccess: "Accès exclu avec succès",
	editAccessPolicySuccess: "Accès modifié avec succès",
	createAccessPolicySuccess: "Accès créé avec succès",
	importAccessPolicyTagsSuccess: "Ids importées avec succès",
	accesses: "Accès",
	sectorAccesses: "Accès du secteur",
	modelFileName: "modèle-de-feuille-de-calcul",
	noSectors: "Aucun secteur enregistré",
	tagIdsError: "Ajoutez au moins un ID de ZigCard",
	onlySpacesError: "Le champ ne peut pas contenir uniquement des espaces",
	seeZigCards: "Voir les ZigCards",
};
